import React, { useEffect } from 'react';
// useLocation 제거 (현재 사용되지 않음)
import ArtistAvailabilityCalendar from '../components/ArtistAvailabilityCalendar';
import styles from './PublicCalendarWrapperPage.module.css';

export default function PublicCalendarWrapperPage() {
  // artistName은 현재 사용되지 않지만 추후 확장용으로 남겨둠
  // const artistName = params.get('artist');

  // PWA 노치 색상을 페이지 배경색(#fff)과 통일
  useEffect(() => {
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    const originalColor = themeColorMeta?.getAttribute('content');

    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', '#fffdf8');
    }

    return () => {
      if (themeColorMeta && originalColor) {
        themeColorMeta.setAttribute('content', originalColor);
      }
    };
  }, []);

  return (
    <div className={styles.publicCalendarWrapper} style={{ overflow: 'auto', height: '100%' }}>
      {/* 공개 캘린더 컨테이너 */}
      <div className={styles.calendarContainer}>
        <ArtistAvailabilityCalendar />
      </div>
      {/* 플로팅 메뉴 여백 */}
      <div style={{ height: 100 }} />
    </div>
  );
}
